import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { Component, forwardRef, Inject, OnInit } from '@angular/core'
import { AttachmentService } from '../../services/attachment.service'
import { DialogService } from '../../../../core/services/dialog.service'
import { ErrorService } from '../../../../core/services/error.service'
import { NonCadastralContractCreateActions } from '../../../../features/non-cadastral/non-cadastral-contract/create/state/action-types'
import { SharedLinkUpdatedService } from '../../components/attachments-simple/shared-link-updated.service'
import { ContractShowActions } from '../../../../features/contracts/contract/show/state/action-types'
import { Store } from '@ngrx/store'
import { SubcontractShowActions } from '../../../../features/contracts/subcontract/show/state/action-types'

@Component({
    selector: 'ca-edit-docx-dialog',
    templateUrl: './edit-docx-dialog.html',
    standalone: false
})
export class EditDocxDialogComponent extends CaDialogComponent<{
    attachmentId: number;
    onlineDocumentLink: string;
    task: string;
}, any> implements OnInit {

    docxPopupEnabled = false
    uploadingToSharepoint = false
    attachmentId: number
    onlineDocumentLink: string
    task: string

    constructor(@Inject(Store) private store: Store,
                @Inject(forwardRef(() => AttachmentService)) private attachmentService: AttachmentService,
                @Inject(forwardRef(() => DialogService)) private dialogService: DialogService,
                @Inject(ErrorService) private errorService: ErrorService,
                @Inject(SharedLinkUpdatedService) private sharedLinkUpdatedService: SharedLinkUpdatedService,
    ) {
        super()
    }
    ngOnInit() {
        if (!this.onlineDocumentLink?.length) {
            this.getSharedLink()
        }
    }

    closeModal(result: boolean): void {
        super.result = result
        super.close()
    }

    openSharedLink(): void {
        if (this.uploadingToSharepoint || !this.onlineDocumentLink?.length) {
            return
        }
        this.attachmentService.openOffice365Window(this.onlineDocumentLink)
        super.close()
    }

    toggleDocxPopupEnabled(): void {
        this.docxPopupEnabled = !this.docxPopupEnabled
        if (this.docxPopupEnabled) {
            localStorage.setItem('ca_docxPopupEnabled', 'true')
        } else {
            localStorage.removeItem('ca_docxPopupEnabled')
        }
    }

    private getSharedLink(): void {
        this.uploadingToSharepoint = true
        this.attachmentService.getAttachmentEditLink(this.attachmentId).then((sharedLink) => {
            this.onlineDocumentLink = sharedLink
            this.uploadingToSharepoint = false
            switch (this.task) {
                case 'contract':
                    this.store.dispatch(ContractShowActions.setAttachmentOnlineDocumentLink({ id: this.attachmentId, link: sharedLink }))
                    break
                case 'subcontract':
                    this.store.dispatch(SubcontractShowActions.setAttachmentOnlineDocumentLink({ id: this.attachmentId, link: sharedLink }))
                    break
                case 'nonCadastralContract':
                    this.store.dispatch(NonCadastralContractCreateActions.setAttachmentOnlineDocumentLink({ id: this.attachmentId, link: sharedLink }))
                    break
                default:
                    this.sharedLinkUpdatedService.emit(sharedLink)
                    break
            }
        }).catch((error) => {
            this.uploadingToSharepoint = false
            this.errorService.onErrorResponseAlertUser(error, 'Chyba při nahrávání online dokumentu.')
            throw new Error(error)
        })
    }

}